import { store } from '@utils/configStore'
import { optInitialSetupServiceOrderReducer } from './slices'

export const injectOPTInitialSetupServiceStore = () => store.injectReducer('optInitialSetupServiceOrder', optInitialSetupServiceOrderReducer)
